import React from 'react';
import { Container } from '@pixi/react';
import JackPotSceneNumberItemContent from './jackPotSceneNumberItemContent';

function JackPotSceneNumberItemWrapper({ winIcon, jackPotItemEnum }) {
  return (
    <Container name='JackPotCardsSectionContainer'>
      {jackPotItemEnum.map((item) => {
        return (
          <JackPotSceneNumberItemContent
            x={item.x}
            y={item.y}
            id={item.id}
            key={item.id}
            type={item.type}
            winIcon={winIcon}
            image={item.image}
            containerName={item.name}
          />
        );
      })}
    </Container>
  );
}

export default JackPotSceneNumberItemWrapper;
